import ChannelCard from "../../Utilities/ChannelCard";
import logoTikTok from "../../../../../images/logos/logo_tiktok.svg";
import useTikTokSetup from "./useTikTokSetup";

export default function TikTokProvider(){
    const { initiateTikTokSetup } = useTikTokSetup({ callbackPath: '/tiktok/accounts' })

    return(
        <ChannelCard
            icon={logoTikTok}
            label={'TikTok'}
            description={'Get social support and moderation, and engage potential customers with organic comments on relevant posts'}
            onClick={initiateTikTokSetup}
        />
    )
}